(function () {
  function init() {
    var triggers = document.querySelectorAll('.js-short-description-readmore');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var selector = trigger.getAttribute('data-target') || '[data-product-description-details]';
      var target = document.querySelector(selector);

      if (!target) return;

      trigger.removeAttribute('hidden');

      trigger.addEventListener('click', function (event) {
        event.preventDefault();

        // Keep opening the "Descrizione" accordion.
        if (target.tagName.toLowerCase() === 'details') {
          target.open = true;
        }

        // Scroll to the add-to-cart height (not the long description), so the
        // price/ATC stay in view while "Descrizione" remains open below.
        var scrollAnchor =
          document.querySelector('.product-info__add-to-cart') ||
          document.querySelector('.product-info__atc-btn') ||
          document.querySelector('button[name="add"]');

        var summary = target.querySelector('summary');

        if (!scrollAnchor) {
          scrollAnchor = summary || target;
        }

        // Offset the scroll by the sticky header height so the ATC lands just
        // below the header. This guarantees the "Descrizione" content (which
        // sits right under the ATC) is never hidden behind the sticky header.
        var headerHeight =
          parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
          ) || 0;
        scrollAnchor.style.scrollMarginTop = headerHeight + 12 + 'px';

        scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Keep focus on the opened description for accessibility, without
        // overriding the scroll position set above.
        var focusEl = summary || target;
        if (typeof focusEl.focus === 'function') {
          focusEl.focus({ preventScroll: true });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
